import axios from "axios";

const BASE = process.env.REACT_APP_API_URL || "https://aivionlearn.aivion.ai/api";

const client = axios.create({
  baseURL: BASE,
  headers: { "Content-Type": "application/json" },
  timeout: 120000,
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const assessmentAPI = {
  generate: async (role, questionCount = 15) => {
    const res = await client.post(
      `/assessment/role/generate?role=${encodeURIComponent(role)}&question_count=${questionCount}`,
    );
    return res.data;
  },

  getInstance: async (instanceId) => {
    const res = await client.get(`/assessment/role/instance/${instanceId}`);
    return res.data;
  },

  submit: async (instanceId, answers, timeSpentMinutes) => {
    const res = await client.post("/assessment/role/submit", {
      instance_id: instanceId,
      answers,
      time_spent_minutes: timeSpentMinutes,
    });
    return res.data;
  },

  getResult: async (responseId) => {
    const res = await client.get(`/assessment/role/result/${responseId}`);
    return res.data;
  },
};
